import { $http } from "@/assets/js/appFunc"; // eslint-disable-line

export const getFeatures = (context) => {
    const req = {
        type: "GET",
        url: "/identity/feature/all"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(data => {
            context.commit("setFeatures", data.data);
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getFeaturesByTenant = (context) => {
    const req = {
        type: "GET",
        url: "/identity/feature/all/flags"
    };
    $http(req, true).then(
        data => {
            context.commit("setFeaturesByTenant", data.data);
        },
        error => error
    );
};

export const getFeatureDetailsByCode = (context, payload) => {
    const req = {
        type: "GET",
        url: `/identity/feature/details/${payload}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const saveLabsFeatures = (context, payload) => {
    context.commit("setFeaturesByTenant", payload);
    const req = {
        type: "POST",
        url: "/identity/feature/save",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(data => {
            resolve(data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const timelineEnabledFeature = (context) => {
    const req = {
        type: "GET",
        url: "/identity/feature/FULL_TIMELINE"
    };
    $http(req, true).then(
        data => context.commit("setTimelineEnabledFeature", data),
        error => error
    );
};

export const actPublicEnrollmentApps = () => {
    const req = {
        type: "GET",
        url: "/engine/api/apps/signup"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(data => {
            resolve(data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getServiceConfiguration = (context, scanningService) => {
    const req = {
        type: "POST",
        url: "/identity/feature/file-scanning/settings",
        data: scanningService
    };

    return $http(req, true);
};

export const deleteServiceConfig = (context, fileId) => {
    const req = {
        type: "DELETE",
        url: `/identity/feature/${fileId}/file-scanning/disable`
    };

    return $http(req, true);
};
